import React from 'react';
import PropTypes from 'prop-types';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import ScenarioSelectionRedefinedSectionMetaOverride
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ScenarioSelectionRedefinedSectionMetaOverride';
import { ProposalOutflowsSectionLayout } from './ProposalOutflowsSectionLayout';

export const ProposalOutflowsSection = ({ resource }) => {
  return (
    <MetaResourceRenderer
      resource={resource}
      layout={ProposalOutflowsSectionLayout}
      metaOverrideSet={ScenarioSelectionRedefinedSectionMetaOverride}
    />
  );
};

ProposalOutflowsSection.propTypes = {
  resource: PropTypes.object.isRequired,
};
